(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const selects = document.querySelectorAll(".collection-filters select");

    selects.forEach(select => {
        select.addEventListener("change", updateURLWithFilters);
    });

    function updateURLWithFilters() {
        const params = new URLSearchParams(window.location.search);

        selects.forEach(select => {
            const name = select.getAttribute("name");
            const value = select.value;
            
            if (value) {
                params.set(name, value); // Set or update the parameter
            } else {
                params.delete(name); // Remove the parameter if value is empty
            }
        });

        // Convert params to a string and replace spaces with '+'
        const queryString = params.toString().replace(/%20/g, "+");

        // Reload the page with the updated URL
        window.location.search = queryString;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const recSlider = new Swiper('ul.h', {
            // Optional parameters
            slidesPerView: 1.3,
            spaceBetween: 5,
            breakpoints: {
              990: {
                slidesPerView: 4
              }
            }
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
